module.exports = __webpack_public_path__ + "img/youtube.a74a8bc2.svg";